import { CreateFtlQuote } from "~/features/ftl/ftl-quotes/create-quote/create-ftl-quote.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const FTLQuotingPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("enableTraxFtlModernized");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <CreateFtlQuote /> : <Construction />;
};
